import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  standalone: true,
  selector: 'crm-days-of-week-single-select',
  templateUrl: './days-of-week-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DaysOfWeekSingleSelectComponent {
  public _value: { name: string; value: number };

  @Input() public readonly options = [
    { name: 'Понедельник', value: 1 },
    { name: 'Вторник', value: 2 },
    { name: 'Среда', value: 3 },
    { name: 'Четверг', value: 4 },
    { name: 'Пятница', value: 5 },
    { name: 'Суббота', value: 6 },
    { name: 'Воскресенье', value: 7 }
  ];

  @Input() public isError = false;
  @Input() public appendTo: string;

  @Input() public set value(value: number) {
    this._value = this.options.find((opt) => opt.value === value);
  }

  @Output() public valueChange = new EventEmitter<number>();
}
